/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_COPY_BATCH_STATUS_REQUESTED,
  COURSE_COPY_BATCH_STATUS_FETCHED,
  COURSE_COPY_BATCH_STATUS_FAILED
} from '../../../common/constants';

export default class CourseCopyBatchStatusService extends BaseService {
  constructor() {
    super(COURSE_COPY_BATCH_STATUS_REQUESTED, 'courseCopyBatchStatus');
  }

  handleEvent(eventName, { courseCopyBatchId }) {
    return this.getClient('marin').get(`/copy-batches/${courseCopyBatchId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }) {
    Framework.getEventManager().publish(COURSE_COPY_BATCH_STATUS_FETCHED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_COPY_BATCH_STATUS_FAILED, error);
  }
}
